<script setup>
import { ref } from 'vue';
import { dasherize } from '../../libs/strings';
import { useJqueryComponents } from '../../mixins/cifra/ComponentesJQuery';

const props = defineProps({
  indicadores: { type: Array, required: true },
});

const container = ref(null);

// Cargar componentes jQuery cuando se actualiza
useJqueryComponents(container, { update: true });

const clasesIcono = (indicador) => {
  const nombre = dasherize(indicador.icono);
  let clases = `fa fa-${nombre} text-${indicador.color}`;
  if (indicador.modal) {
    clases = `${clases} clickable`;
  }
  return clases;
};

const clasesIndicador = (indicador) => {
  let clases = 'indicador';
  if (indicador.modal) {
    clases = `${clases} clickable`;
  }
  return clases;
};

const tipoToggle = (indicador) => {
  if (indicador.tooltip) {
    return 'tooltip';
  }
  return undefined;
};

const tipoController = (indicador) => {
  if (indicador.modal) {
    return 'modal-remoto';
  }
  return undefined;
};
</script>

<template>
  <div ref="container">
    <span
      v-for="indicador in indicadores"
      :key="indicador.tipo"
      :class="clasesIndicador(indicador)"
      :data-toggle="tipoToggle(indicador)"
      :data-controller="tipoController(indicador)"
      :title="indicador.tooltip"
      :data-url="indicador.modal"
      data-modal-classes="modal-cifra-lg"
    >
      <i :class="clasesIcono(indicador)"></i>
    </span>
  </div>
</template>

<style scoped>
  .indicador {
    margin-right: 4px;
  }
</style>
